import { useNavigate } from "react-router-dom";

import { Button } from "@/components";
import { CircleCheck } from "@/icons";
import { useTranslate, useUser } from "@/providers/context";

export const ResetPasswordSuccess = () => {
  const navigate = useNavigate();
  const { translate } = useTranslate();
  const { uid } = useUser();

  const handleClick = () => {
    if (uid) {
      navigate("/", { replace: true });
    } else {
      navigate("/sign-in", { replace: true });
    }
  };

  const buttonText = uid ? "Start Browsing" : "Return To Sign In";

  return (
    <div className="text-item-primary flex flex-col items-center">
      <CircleCheck className="h-[68px] w-[68px] text-highlightPrimary" />
      <div className="h1 mb-[12px] mt-[20px]">
        {translate("Password Changed!")}
      </div>
      <div className="p1-regular sm:h5-regular text-center sm:mb-[52px]">
        {translate("You have successfully reset your password.")}
      </div>
      <div className="bg-surface-primary border-border fixed bottom-0 left-0 right-0 flex w-full flex-col items-center border-t px-5 py-4 sm:relative sm:border-none sm:p-0">
        <Button
          className="text-md h-fit w-full max-w-[440px] px-[14px] py-[10px] sm:mt-[8px] sm:text-sm"
          onClick={handleClick}
        >
          {translate(buttonText)}
        </Button>
      </div>
    </div>
  );
};
